module.exports = __webpack_public_path__ + "static/media/accepted-icon.6bedfe2b.svg";